import styles from './styles.scss';
import { rm } from 'utils';
import { IconMail } from 'components/Shared/Icon/themes/BGH-RD3/iconMail';
import cn from 'classnames';

interface BubbleProps {
  isDiscount: boolean;
  isStickyMode?: boolean;
}

const DiscountContent = (isStickyMode?: boolean) => {
  return (
    <div className={cn(styles.discountContentContainer, { [styles.stickyMode]: isStickyMode })}>
      <div>
        <span className={cn(styles.discountAmount, { [styles.stickyMode]: isStickyMode })}>
          {rm('Newsletter_Push_Discount_Amount')}
        </span>
      </div>
      <div className={styles.stackedText}>
        <span className={cn(styles.percentage, { [styles.stickyMode]: isStickyMode })}>%</span>
        <span className={cn(styles.discount, { [styles.stickyMode]: isStickyMode })}>
          {rm('Newsletter_Push_Discount_Header')}
        </span>
      </div>
    </div>
  );
};

export const Bubble = ({ isDiscount, isStickyMode }: BubbleProps) => {
  const content = isDiscount ? DiscountContent(isStickyMode) : <IconMail />;

  return <div className={cn(styles.bubble, { [styles.stickyMode]: isStickyMode })}>{content}</div>;
};
